import React, { useState, useEffect } from 'react';
import { Table } from 'reactstrap';
import * as moment from 'moment';
import styled from 'styled-components'
import Tooltip from '@material-ui/core/Tooltip';
import CurrencyFormat from 'react-currency-format';
import { useHistory } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import information from 'web/assets/images/information.png';
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import YesNoModal from "web/components/YesNoModal";
import styles from './table.module.scss';
import { sellerInvCheckoutRejectApi } from 'redux/actions/checkout';
import MobileViewAccordion from './MobileView';

const ReactTable = ({ pageLanguageContents, response, currentPageNumber, filterState, callBackFetchApi }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [modal, setModal] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const [yesNomodal, setYesNoModal] = useState(false);
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [isActiveBuyNowOffersExists, setIsActiveBuyNowOffersExists] = useState(false)
  const [storedOfferId, setStoreOfferId] = useState()
  let title = '';
  const [pageActive, setPageActive] = useState("");
  const [confirmationComment, setConfirmationComment] = useState("");
  const [activeClass, setActiveClass] = useState({
    buyNow: 'active',
    buyNowCpu: 'active',
    bids: 'active',
    offer: 'active'
  });

  const headerArr = [
    { title: "Buyer Located Near" },
    { title: 'Offer Price' },
    { title: "Qty" },
    { title: "Delivery Date" },
    { title: "Delivery Time" },
    { title: 'Offer Status' },
    { title: '' }
  ];

  const headerOfferArr = [
    { title: "Buyer Located Near" },
    { title: 'Offer Price' },
    { title: "Qty" },
    { title: pageLanguageContents?.TableHeaders[6]?.Date },
    { title: pageLanguageContents?.TableHeaders[7]?.Time },
    { title: "Mode" },
    { title: 'Offer Status' },
    { title: '' }
  ];

  const headerPickupArr = [
    { title: "Buyer Located Near" },
    { title: 'Offer Price' },
    { title: "Qty" },
    { title: "Pickup Date" },
    { title: "Pickup Time" },
    { title: 'Offer Status' },
    { title: '' }
  ];

  useEffect(() => {
    let hasActiveBuyNowOffer = response.buyNowOfferDetails?.some(offer => offer.offerStatusMessage?.toLowerCase()?.includes('received'));
    let hasActiveBuyNowCpuOffer = response.pickupOfferDetails?.some(offer => offer.offerStatusMessage?.toLowerCase()?.includes('received'));

    setPageActive("");
    setShowFilterOptions(false);

    if (response.offerDetails && response.offerDetails.length !== 0) {
      setActiveClass({ offer: "active" });
      setPageActive("Offers");
      setShowFilterOptions(true);
    }
    if (response.buyNowOfferDetails && response.buyNowOfferDetails.length !== 0) {
      setActiveClass({ buyNow: "active" });
      setPageActive("BuyNow");
      setShowFilterOptions(true);
    }
    if (response.pickupOfferDetails && response.pickupOfferDetails.length !== 0) {
      setActiveClass({ buyNowCpu: "active" });
      setPageActive("BuyNowCpu");
      setShowFilterOptions(true);
    }

    setIsActiveBuyNowOffersExists(hasActiveBuyNowOffer || hasActiveBuyNowCpuOffer);
  }, [response]);

  const timeFormat = (timeString) => {
    let H = +timeString.substr(0, 2);
    let h = H % 12 || 12;
    let ampm = H < 12 ? ' AM' : ' PM';
    return h + timeString.substr(2, 3) + ampm;
  };

  const tootTip = () => {
    return (
      <Tooltip placement="top" enterTouchDelay={0} arrow title={<p>{pageLanguageContents?.Contents[27]?.Alert1}</p>}>
        <img src={information} />
      </Tooltip>
    );
  };

  const tableData = (items, postType) => {
    let isAltDate = items.offerType === "ALTOFFER" && new Date(response.requestedDate).getTime() !== new Date(items.requestedDate).getTime();
    const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    return (
      <tr key={items.offerId}>
        <td style={{ fontWeight: items.fcMember ? 'bold' : 'normal' }}>
          <p>{items.companyInfo}</p>
        </td>
        <td>
          {items.offerPrice && <CurrencyFormat value={items.offerPrice.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} />}
        </td>
        <td style={{ fontWeight: (items.offerType === "ALTOFFER" && items.qty !== response.totalQty) ? 'bold' : 'normal' }}>
          <CurrencyFormat value={items.qty || response.totalQty} displayType={'text'} prefix={''} />
        </td>
        <td style={{ fontWeight: items.offerType === "ALTOFFER" && isAltDate ? 'bold' : 'normal' }}>
          <span>{items.outsideWorkingDays ? <span className="orangeStatus">{moment(items.requestedDate).format(FORMAT)}{tootTip()}</span> : <span>{moment(items.requestedDate).format(FORMAT)}</span>}</span>
        </td>
        <td>{items.appointmentStartTime && timeFormat(items.appointmentStartTime)}-{items.appointmentEndTime && timeFormat(items.appointmentEndTime)}</td>
        {postType === "offer" && <td>{capitalizeFirstLetter(items.shippingMode)}</td>}
        <td>{items.offerStatusMessage}</td>
        <td style={{ display: 'flex' }}>
          {(items.offerStatusMessage?.toLowerCase()?.includes('accepted') || items.offerStatusMessage?.toLowerCase()?.includes('received')) ?
            <Button
              type='app-green-button'
              disabled={!(true)}
              handleClick={() => {
                let obj = {
                  id: items.offerId?.toString(),
                  type: 'sellerInvCheckout'
                }
                dispatch({ type: 'CHECKOUT', payload: obj });
                let obj2 = { selectedPage: currentPageNumber, filterState: filterState };
                dispatch({ type: "BIDS_PAGINATION", payload: obj2 });
                history.push({ pathname: '/checkout' });
              }}
            >
              {pageLanguageContents?.Contents[28]?.View}
            </Button>
            : ""
          }
          {(items.offerStatusMessage?.toLowerCase()?.includes('received')) ?
            <div style={{ marginLeft: '10px' }}>
              <Button
                type='app-green-button'
                disabled={!(true)}
                handleClick={() => {
                  declineOfferFunction(items.offerId)
                }}
              >
                Decline
              </Button>
            </div>
            : ""
          }
        </td>
      </tr>
    );
  };

  const declineOfferFunction = (offerIdVal) => {
    setYesNoModalContent("Are you sure you want to decline this offer?");
    setStoreOfferId(offerIdVal);
    setYesNoModal(true);
  };

  const declineOfferFunctionConfirmation = async () => {
    let response;
    const token = localStorage.getItem('token');
    let data = {
      authId: localStorage.getItem('authId'),
      offerId: storedOfferId,
      comment: confirmationComment || null
    };
    response = await dispatch(sellerInvCheckoutRejectApi(data, token));
    if (response?.success) {
      setAlertType('sellerInvCheckoutReject');
      setModalContent(response?.data?.msg);
      setModalLink();
      setModal(true);
    } else {
      setModalLink("");
      setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
      setModal(true);
    }
  };

  const buyNow = () => (
    <Table responsive>
      <thead>
        <tr>{headerArr.map((items, index) => <th key={index}>{items.title}</th>)}</tr>
      </thead>
      <tbody>
        {response.buyNowOfferDetails && response.buyNowOfferDetails.map((items, subAccIndex) => tableData(items, "buynow"))}
      </tbody>
    </Table>
  );

  const buyNowCpu = () => (
    <Table responsive>
      <thead>
        <tr>{headerPickupArr.map((items, index) => <th key={index}>{items.title}</th>)}</tr>
      </thead>
      <tbody>
        {response.pickupOfferDetails && response.pickupOfferDetails.map((items, subAccIndex) => tableData(items, "buynowcpu"))}
      </tbody>
    </Table>
  );

  const Offers = () => (
    <Table responsive>
      <thead>
        <tr>{headerOfferArr.map((items, index) => <th key={index}>{items.title}</th>)}</tr>
      </thead>
      <tbody>
        {response.offerDetails && response.offerDetails.map((items, subAccIndex) => tableData(items, "offer"))}
      </tbody>
    </Table>
  );

  return (
    <>
      <Filter>
        {showFilterOptions && <span>{pageLanguageContents?.TableHeaders[11]?.FilterBy}</span>}
        {(response?.buyNowOfferDetails && response?.buyNowOfferDetails?.length !== 0) &&
          <div className={activeClass.buyNow} onClick={() => {
            setActiveClass({ buyNow: "active" })
            setPageActive("BuyNow")
          }}>
            {pageLanguageContents?.TableHeaders[12]?.BuyNow}
          </div>
        }
        {(response?.pickupOfferDetails?.length !== 0) &&
          <div className={activeClass.buyNowCpu} onClick={() => {
            setActiveClass({ buyNowCpu: "active" })
            setPageActive("BuyNowCpu")
          }}>
            {pageLanguageContents?.TableHeaders[13]?.Pickup}
          </div>
        }
        {(response?.offerDetails?.length !== 0 && !isActiveBuyNowOffersExists) &&
          <div className={activeClass.offer} onClick={() => {
            setActiveClass({ offer: "active" })
            setPageActive("Offers")
          }}>
            {pageLanguageContents?.TableHeaders[15]?.Offers}
          </div>}

      </Filter>
      <div className={`${styles.tableContainer} ${styles.webView}`}>
        {pageActive === "BuyNowCpu" && buyNowCpu()}
        {pageActive === "BuyNow" && buyNow()}
        {pageActive === "Offers" && Offers()}
      </div>

      <div className={styles.mobileView}>
        {(pageActive === "BuyNowCpu" || pageActive === "BuyNow" || pageActive === "Offers") &&
          <MobileViewAccordion
            offerType={pageActive}
            apiResponse={response}
            currentPageNumber={currentPageNumber}
            timeFormat={timeFormat}
            declineOfferFunction={declineOfferFunction}
            pageLanguageContents={pageLanguageContents}
            tootTip={tootTip}
            filterState={filterState}
          />
        }
      </div>

      <AlertModal
        isOpen={modal}
        toggle={() => setModal(false)}
        title=""
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => {
          if (alertType === 'sellerInvCheckoutReject') {
            callBackFetchApi();
          }
        }}
      />
      <YesNoModal
        isOpen={yesNomodal}
        toggle={() => {
          setYesNoModal(false);
          setConfirmationComment("");
        }}
        title=""
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            declineOfferFunctionConfirmation()
          }
        }}
        content={yesNoModalContent}
        link="/"
        enableConfirmationComment={true}
        confirmationComment={confirmationComment}
        setconfirmationComment={setConfirmationComment}
        confirmationCommentBoxLabel={"Note to Buyer"}
      />
    </>
  );
};

export default ReactTable;

const Filter = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  align-items:center;
  > div {
    border: 1px solid lightgray;
    padding: 5px 10px;
    min-width: 50px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 3px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 36px;
    font-size: 17px;
    font-family: 'latobold';
    color: #717171;
    :hover {
      background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
      color: white;
      border: 1px solid lightgray;
    }
  }
  .active {
    background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
    color: white;
    border: 1px solid lightgray;
  }
`;
